import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Analytics from '../../../../analytics/Analytics';
import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import FormFieldId from '../../../../types/FormFieldId';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutCustomerInfo from '../CheckoutCustomerInfo';

const CheckoutCustomerInfoModule = ({
  analytics,
  checkoutStore,
  onOrderUpdate,
  orderNumber,
}) => {
  const { order } = checkoutStore;
  const { customerInfoAlerts } = order;

  const sendGdprData = () => {
    const customerEmail = order.getCustomerField(
      FormFieldId.BILLING_EMAIL
    ).value;

    // Move to service if there starts to be gdpr related logic.
    order.gdpr_info && customerEmail && analytics.sendGdprData(order.gdpr_info);
  };

  const sendAnalyticEvents = () => {
    sendGdprData();
  };

  const handleUpdate = ({ withoutTimer }) => {
    sendAnalyticEvents();
    onOrderUpdate({
      module: CheckoutPageModule.CUSTOMER_INFO_MODULE,
      withoutTimer,
    });
  };

  return (
    <CheckoutModule
      className="CheckoutCustomerInfoModule"
      generalAlerts={customerInfoAlerts.general}
      errorAlerts={customerInfoAlerts.errors}
      title={<FormattedMessage {...globalTranslations.contactInformation} />}
      orderNumber={orderNumber}
      module={CheckoutPageModule.CUSTOMER_INFO_MODULE}
    >
      <CheckoutCustomerInfo
        onOrderUpdate={handleUpdate}
        orderNumber={orderNumber}
      />
    </CheckoutModule>
  );
};

CheckoutCustomerInfoModule.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  analytics: PropTypes.instanceOf(Analytics).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject(
  'analytics',
  'checkoutStore'
)(observer(CheckoutCustomerInfoModule));
